enum DefaultControlType {
    INLINE = 'inline',
    BLOCK = 'block',
}

export default DefaultControlType;
